export default "__VITE_ASSET__ca988176__"